if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"master","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(client_components_(Containers_Desktop_HeaderContainer_header_scss\-client_components_Containers\-45ef94|Swiper_swiper_scss\-client_styles_master_plugins__date\-picker_scss)|webpack_sharing_consume_default_react(\-(dom_react|router\-dom_react\-router)\-dom|_react)|runtime)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}